/* eslint-disable sonarjs/cognitive-complexity */
import axios from 'axios';
import { APIEndpoints } from 'helpers/APILists';
import { TAGS_ACTIONS } from '../TagSelectionMOScreen/TagSelectionMOScreen.constants';
import { sortFunction } from '../SubSections/DPS/DPS.helpers';
import { MESSAGE_TYPE } from '../../common/common.constants';

const selectedRowTagsFilters = (res) => res.data.map((item) => ({
    ...item,
    DeckHullBldg: item.DeckHullBldg === '' ? ' ' : item.DeckHullBldg,
    Quad: item.Quad === '' ? ' ' : item.Quad,
    Level: item.Level === '' ? ' ' : item.Level,
    Room: item.Room === '' ? ' ' : item.Room,
    Location2: item.Location2 === '' ? ' ' : item.Location2
}));

export const setHdLocationSortOrder = (columnName) => (dispatch, getState) => {
    const { TagSelectionMOScreen: { sortHdLocationAscOrder, selectedRowTags, selectedRowTagsTableData, clearFilters } } = getState();
    dispatch({
        type: TAGS_ACTIONS.HDLOCATION_SORTORDER_NONMO,
        payload: {
            sortHdLocationAscOrder: !sortHdLocationAscOrder,
        }
    });
    if (!clearFilters) {
        dispatch(sortTags(selectedRowTagsTableData, columnName, !sortHdLocationAscOrder));
    } else {
        dispatch(sortTags(selectedRowTags, columnName, !sortHdLocationAscOrder));
    }
};

export const sortTags = (tagsData, colForSorting, sortAscOrder) => (dispatch, getState) => {
    dispatch({
        type: TAGS_ACTIONS.GET_SORTTAGRECORDS_PENDING_NONMO,
        payload: {
            tableLoading: true
        }
    });
    const { TagSelectionMOScreen: { clearFilters } } = getState();
    sortFunction(tagsData, colForSorting, sortAscOrder)
        .then(sortedData => {
            !clearFilters ? dispatch({
                type: TAGS_ACTIONS.GET_SORTTAGRECORDS_SUCCESS_NONMO,
                payload: {
                    tableLoading: false,
                    selectedRowTagsTableData: sortedData
                }
            }) : dispatch({
                type: TAGS_ACTIONS.GET_SORTTAGRECORDS_SUCCESS_NONMO,
                payload: {
                    tableLoading: false,
                    selectedRowTags: sortedData
                }
            });
        }
        )
        .catch(error => {
            dispatch({
                type: TAGS_ACTIONS.GET_SORTTAGRECORDS_FAILURE_NONMO,
                payload: {
                    tableLoading: false,
                },
                meta: { messageType: MESSAGE_TYPE.ERROR, message: error.message, exception: error }
            });
        }
        );
};

function searchFLOCFunction(searchVal = '', searchSpace = []) {
    return new Promise((resolve, reject) => {
        try {
            if (searchVal === '') {
                resolve(searchSpace);
            } else {
                const filteredData = searchSpace.filter(row => row.HdLocation?.toLowerCase().includes(searchVal?.toLowerCase()));
                resolve(filteredData);
            }
        } catch (e) {
            reject(e);
        }
    }
    );
}

export const searchFLOC = (searchVal, hdWorkOrder) => async (dispatch, getState) => {
    const { TagSelectionMOScreen: { selectedRowTags, clearFilters, selectedRowTagsTableData } } = getState();
    await dispatch({
        type: TAGS_ACTIONS.GET_SEARCHTAGRECORDS_PENDING_NONMO,
        payload: {
            tableLoading: true,
            flocSearchString: searchVal
        }
    });

    const searchSpace = clearFilters ? selectedRowTags : selectedRowTagsTableData;
    searchFLOCFunction(searchVal, searchSpace)
        .then(searchedData => {
            const totalCount = searchedData.length;
            dispatch({
                type: TAGS_ACTIONS.GET_SEARCHTAGRECORDS_SUCCESS_NONMO,
                payload: {
                    tableLoading: false,
                    searchedRowTagsTableData: searchedData,
                    totalCount
                }
            });
        }
        )
        .catch(error => {
            dispatch({
                type: TAGS_ACTIONS.GET_SEARCHTAGRECORDS_FAILURE_NONMO,
                payload: {
                    tableLoading: false,
                },
                meta: { messageType: MESSAGE_TYPE.ERROR, message: error.message, exception: error }
            });
        }
        );
};

export const getSelectTagScreenNonMoData = () => async (dispatch, getState) => {
    const { AppData: { isMRATOnline }, Home: { bpRegionNameAlias, selectedAssetAliasName, IsLateEntry }, TagSelectionMOScreen: { flocSearchString } } = getState();
    const encodedRegionName = encodeURIComponent(bpRegionNameAlias);
    const encodedAssetName = encodeURIComponent(selectedAssetAliasName);

    if (isMRATOnline) {
        dispatch(fetchAndSetNonMoTagLimitHours(bpRegionNameAlias));
        dispatch({
            type: TAGS_ACTIONS.GET_TAGRECORDS_PENDING_NONMO,
            payload: {
                tableLoading: true,
                flocSearchString: ''
            }
        });

        await axios.get(`${APIEndpoints.GetNonMoTrfLogs}?AssetName=${encodedAssetName}&BpRegion=${encodedRegionName}&IsLateEntry=${IsLateEntry}`)
            .then((res) => {
                const filteredDataLateEntry = res.data.filter(item => item.IsLateEntry === true);
                const filteredDataNonMo = res.data.filter(item => item.IsNonMoTrf === true);
                const finalData = IsLateEntry ? filteredDataLateEntry : filteredDataNonMo;
                let selectedRowTags = selectedRowTagsFilters({ data: finalData });
                selectedRowTags = selectedRowTags.map((item) => ({
                    ...item,
                    HdWorkOrder: item.MO
                }));

                selectedRowTags = selectedRowTags.sort((a, b) => {
                    const LastModifiedDateA = a.LastModifiedDate ? new Date(a.LastModifiedDate).getTime() : 0;
                    const LastModifiedDateB = b.LastModifiedDate ? new Date(b.LastModifiedDate).getTime() : 0;
                    return LastModifiedDateB - LastModifiedDateA;
                });
                if (selectedRowTags && selectedRowTags.length > 0) {
                    const totalCount = selectedRowTags.length ?? 0;
                    dispatch({
                        type: TAGS_ACTIONS.GET_TAGRECORDS_SUCCESS_NONMO,
                        payload: {
                            flocSearchString: '',
                            tableLoading: false,
                            selectedRowTags,
                            searchedRowTagsTableData: selectedRowTags
                        }
                    });
                    if (!flocSearchString) {
                        dispatch({
                            type: TAGS_ACTIONS.GET_TAGRECORDS_TOTALCOUNT_NONMO,
                            payload: {
                                totalCount
                            }
                        });
                    }
                } else {
                    dispatch({
                        type: TAGS_ACTIONS.GET_TAGRECORDS_SUCCESS_NONMO,
                        payload: {
                            flocSearchString: '',
                            tableLoading: false,
                            selectedRowTags: [],
                            searchedRowTagsTableData: []
                        }
                    });
                    if (!flocSearchString) {
                        dispatch({
                            type: TAGS_ACTIONS.GET_TAGRECORDS_TOTALCOUNT_NONMO,
                            payload: {
                                totalCount: 0
                            }
                        });
                    }
                }
                return true;
            });
    } else {
        dispatch(getAllOfflineTagSelectionNonMOScreenData());
    }
};

export const getAllOfflineTagSelectionNonMOScreenData = () => async (dispatch, getState) => {
    const { TagSelectionMOScreen: { flocSearchString, selectedRowTags }, Forms: { updatedFormDataObj } } = getState();
    const { F2SapFloc } = updatedFormDataObj;
    if (!F2SapFloc) {
        return;
    }
    const Data = updatedFormDataObj.nonMoObjectData;
    if (!Data) {
        return;
    }
    const isExisting = selectedRowTags.some(
        tag => tag.HdLocation === Data.HdLocation && tag.HdWorkOrder === Data.MO
    );
    if (isExisting) {
        return;
    }
    const finalData = {
        HdLocation: Data?.HdLocation,
        CreatedDate: Data?.CreatedDate,
        CreatedBy: Data?.CreatedBy,
        TrfId: Data?.TrfId,
        TrfshortDesc: Data?.TrfshortDesc,
        HdWorkOrder: Data?.MO,
    };
    const updatedRowTags = [
        finalData,
        ...selectedRowTags.filter(
            tag => !(tag.HdLocation === finalData.HdLocation && tag.HdWorkOrder === finalData.HdWorkOrder)
        )
    ];
    const totalCount = updatedRowTags.length;
    dispatch({
        type: TAGS_ACTIONS.GET_TAGRECORDS_SUCCESS,
        payload: {
            flocSearchString: '',
            tableLoading: false,
            selectedRowTags: updatedRowTags,
        },
    });
    if (!flocSearchString) {
        dispatch({
            type: TAGS_ACTIONS.GET_TAGRECORDS_TOTALCOUNT,
            payload: {
                totalCount,
            },
        });
    }
};

export const setNonMoTagLimitHours = (nonMoTagDuration) => ({
    type: TAGS_ACTIONS.SET_NONMO_TAG_LIMIT_HOURS,
    payload: {
        nonMoTagDuration
    }
});

export const fetchAndSetNonMoTagLimitHours = (bpRegionNameAlias) => async (dispatch, getState) => {
    const { Home: { IsLateEntry } } = getState();
    const res = await axios.get(APIEndpoints.ADMIN_GetBpRegionDetails);
    const matchingRegion = res?.data?.find(region => region.BpRegionAlias === bpRegionNameAlias);
if (IsLateEntry) {
    if (matchingRegion?.LateEntryTagDuration) {
        dispatch(setNonMoTagLimitHours(matchingRegion.LateEntryTagDuration));
    }
} else if (matchingRegion?.NonMoTagDuration) {
        dispatch(setNonMoTagLimitHours(matchingRegion.NonMoTagDuration));
    }
};
